<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/CONCLUSION.mp4'

export default {
    name: 'conclusion-video',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/review"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
